import { render, staticRenderFns } from "./viewBranch.vue?vue&type=template&id=43166260&scoped=true&"
import script from "./viewBranch.vue?vue&type=script&lang=js&"
export * from "./viewBranch.vue?vue&type=script&lang=js&"
import style0 from "./viewBranch.vue?vue&type=style&index=0&id=43166260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43166260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43166260')) {
      api.createRecord('43166260', component.options)
    } else {
      api.reload('43166260', component.options)
    }
    module.hot.accept("./viewBranch.vue?vue&type=template&id=43166260&scoped=true&", function () {
      api.rerender('43166260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/viewBranch.vue"
export default component.exports